/** johnDeere.* locale keys for a failed John Deere connect (?deere_error=). */
export type JdCallbackErrorKey =
  | "connectErrorBrowserMismatch"
  | "connectErrorAccountMismatch"
  | "connectErrorLinkExpired"
  | "connectErrorAccessDenied";

export type JdCallbackError = { key: JdCallbackErrorKey; fallback: string };

const LINK_EXPIRED: JdCallbackError = {
  key: "connectErrorLinkExpired",
  fallback: "The John Deere connection link expired. Please try again.",
};

/**
 * The codes the backend's /api/v1/johndeere/callback puts into ?deere_error=
 * that the customer can act on. Deere's own OAuth codes arrive there too
 * (access_denied when the customer declines on Deere's consent page).
 */
const ERRORS: Record<string, JdCallbackError> = {
  browser_mismatch: {
    key: "connectErrorBrowserMismatch",
    fallback: "Please finish connecting John Deere in the same browser you started in.",
  },
  account_mismatch: {
    key: "connectErrorAccountMismatch",
    fallback: "This browser is signed in to a different GreenGrowth account.",
  },
  invalid_state: LINK_EXPIRED,
  state_expired: LINK_EXPIRED,
  state_used: LINK_EXPIRED,
  access_denied: {
    key: "connectErrorAccessDenied",
    fallback: "John Deere access was not granted.",
  },
};

/** The message for a ?deere_error= code, or null to show the generic one. */
export const jdCallbackError = (code: string | null | undefined): JdCallbackError | null =>
  (code && Object.prototype.hasOwnProperty.call(ERRORS, code) ? ERRORS[code] : null);
